import { resolveId } from '@medplum/core'
import type { Reference, ServiceRequest } from '@medplum/fhirtypes'
import {
  OrderCategory,
  orderCategoryLabel,
} from '@seen/core/models/orders/constants'
import { Order } from '@seen/core/models/orders/Order'
import type { ReactNode } from 'react'
import { Link } from '#src/components/core/Link.tsx'
import { IconOrder } from '#src/components/icons/IconOrder.tsx'
import { RowBadge } from '#src/components/TaskRowBadge.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { getOrderTitle } from '#src/utils/getOrderTitle.ts'

export function OrderBadge({
  order: orderReference,
}: {
  order: Reference<ServiceRequest>
}): ReactNode {
  const { data: order } = useRead(Order, orderReference)
  const title = getOrderTitle(order)
  const categoryLabel =
    !!order?.category && order.category !== OrderCategory.Misc
      ? orderCategoryLabel(order.category)
      : ''
  return (
    <Link
      to={`/Patient/${resolveId(order?.participant)}/orders/${resolveId(orderReference)}`}
    >
      <RowBadge loading={!order} icon={<IconOrder className="size-3.5" />}>
        {!!categoryLabel && categoryLabel}
        {!!categoryLabel && !!title && ': '}
        {!!title && title}
      </RowBadge>
    </Link>
  )
}
